module.exports = __webpack_public_path__ + "static/img/1-12.59a2869.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/6/1/1-12.png
// module id = WqgF
// module chunks = 0